import { notification } from "antd";
import { useCallback, useState } from "react";
import { useLanguage } from "~/hooks/useLanguage";
import { UpdateExpiredPasswordInput } from "../types/updateExpiredPassword";
import { updateExpiredPassword } from "../services/updateExpiredPassword";
import { UpdateExpiredPasswordError } from "../constant/errorr";

export const useExpiredPassword = () => {
  const { formatMessage } = useLanguage();
  const [loading, setLoading] = useState(false);

  const onExecute = useCallback(
    async (input: UpdateExpiredPasswordInput) => {
      setLoading(true);

      try {
        const response = await updateExpiredPassword(input);

        if (response.succeed) {
          notification.success({
            message: formatMessage(
              "UpdateExpiredPassword.Notification.passwordChanged.message",
            ),
            description: formatMessage(
              "UpdateExpiredPassword.Notification.passwordChanged.description",
            ),
          });
          return true;
        }
      } catch (error) {
        const updateExpiredPasswordError =
          UpdateExpiredPasswordError[(error as Error)?.message as string];
        if (updateExpiredPasswordError) {
          notification.error({
            message: formatMessage(updateExpiredPasswordError.message),
            description: updateExpiredPasswordError?.description
              ? formatMessage(updateExpiredPasswordError?.description)
              : undefined,
          });
        } else {
          notification.error({
            message: (error as Error)?.message,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [formatMessage],
  );
  return {
    updateExpiredPassword: onExecute,
    loading,
  };
};
